import {
  BarChart3,
  Building2,
  Calculator,
  FileSpreadsheet,
  FileText,
  GitCompare,
  Layers,
  LineChart,
  Receipt,
  Scale,
  Users,
} from "lucide-react";

export const TDS_REPORT_TYPES = [
  {
    id: "monthly-register",
    title: "Monthly TDS Register",
    description: "Month-wise TDS deductions for all employees from live payroll data.",
    icon: Receipt,
    tone: "violet",
    statusKey: "register",
  },
  {
    id: "tax-computation",
    title: "Employee Tax Computation",
    description: "Annual tax computation with exemptions and taxable income per employee.",
    icon: Calculator,
    tone: "blue",
    statusKey: "register",
  },
  {
    id: "quarterly-return",
    title: "Quarterly Return (Form 24Q)",
    description: "Track quarterly TDS filing status and acknowledgement details.",
    icon: FileSpreadsheet,
    tone: "emerald",
    statusKey: "quarterly",
  },
  {
    id: "form16",
    title: "Form 16",
    description: "Generate Part A & B tax certificates for employees.",
    icon: FileText,
    tone: "amber",
    statusKey: "form16",
  },
  {
    id: "reconciliation",
    title: "TDS Reconciliation",
    description: "Compare deducted TDS with deposited amounts and identify variances.",
    icon: Scale,
    tone: "rose",
    statusKey: "register",
  },
  {
    id: "branch-wise",
    title: "Branch-wise Report",
    description: "TDS summary grouped by employee branch where available.",
    icon: Building2,
    tone: "slate",
    statusKey: "register",
  },
  {
    id: "department-wise",
    title: "Department-wise Report",
    description: "TDS summary grouped by department.",
    icon: Users,
    tone: "cyan",
    statusKey: "register",
  },
  {
    id: "cost-center",
    title: "Cost Center-wise Report",
    description: "TDS summary by cost center from employee metadata.",
    icon: Layers,
    tone: "purple",
    statusKey: "register",
  },
  {
    id: "tax-ledger",
    title: "Employee Tax Ledger",
    description: "Running view of projected tax and monthly TDS per employee.",
    icon: GitCompare,
    tone: "indigo",
    statusKey: "register",
  },
  {
    id: "annual-projection",
    title: "Annual Projection",
    description: "Projected income, exemptions, and tax liability for the financial year.",
    icon: LineChart,
    tone: "teal",
    statusKey: "register",
  },
];

export const GENERATION_STEPS = [
  "Loading payroll data",
  "Reading employees",
  "Calculating TDS",
  "Preparing report",
  "Generating output",
  "Completed",
];

export const MONTH_OPTIONS = [
  "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar",
];
